export function renderIconPostfixFormFieldTemplate({
  indent,
  fieldName,
  formLabel
}: {
  indent: string
  fieldName: string
  formLabel: string
}): string {
  return `${indent}<FormField
${indent}  control={form.control}
${indent}  name="${fieldName}Icon"
${indent}  render={({ field: formField }) => (
${indent}    <FormItem>
${indent}      ${formLabel}
${indent}      <FormControl>
${indent}        <IconPicker
${indent}          value={formField.value}
${indent}          onValueChange={formField.onChange}
${indent}          triggerPlaceholder="Select icon"
${indent}        />
${indent}      </FormControl>
${indent}      <FormMessage />
${indent}    </FormItem>
${indent}  )}
${indent}/>`
}
